import styled from 'styled-components';
import { COLOR } from 'assets/styles/colors';

export const Container = styled.div`
  width: 100%;
  padding: 0;
  background-color: ${({ recoverPhone }) => (recoverPhone ? '#FBFBFB' : `${COLOR.WHITE_1}`)}; 
`;
